import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  Show,
  SimpleShowLayout,
  Filter,
  usePermissions,
} from 'react-admin'
import { ArchivalToolbar } from '../components/ArchivalToolbar'
import { ArchivedSelect } from '../components/selects'

const ListBase = (props) => {
  const { permissions } = usePermissions()
  return (
    <List
      exporter={permissions?.includes('admin') ? undefined : false}
      filters={<AFSCFilter />}
      perPage={25}
      sort={{ field: 'name', order: 'ASC' }}
      {...props}
    >
      <AFSCList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <AFSCShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <AFSCForm />
  </Create>
)
const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <AFSCForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const AFSCFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <ArchivedSelect />
  </Filter>
)

const AFSCList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField source="name" />
  </Datagrid>
)
const AFSCShow = (props) => (
  <SimpleShowLayout {...props}>
    <TextField fullWidth source="name" />
  </SimpleShowLayout>
)

const AFSCForm = (props) => (
  <SimpleForm warnWhenUnsavedChanges toolbar={<ArchivalToolbar />} {...props}>
    <TextInput fullWidth source="name" />
  </SimpleForm>
)
